// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var ViewStack = require("../../../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../atoms/Icon/Icon__Jsx3.bs.js");
var View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Avatar__Jsx3 = require("../../atoms/Avatar/Avatar__Jsx3.bs.js");
var Theme__Color = require("../../../../reason/common/Theme/Theme__Color.bs.js");
var Chat = require("uikit/molecules/Chat/Chat");

var JS = {};

function Chat__Jsx3$ConversationHeader(props) {
  return React.createElement(Chat.ConversationHeader, {
              icon: Belt_Option.map(props.icon, Icon__Jsx3.iconToString),
              children: props.children
            });
}

var ConversationHeader = {
  JS: JS,
  make: Chat__Jsx3$ConversationHeader
};

var DayDivider = {};

function messageToJs(v) {
  return {
          background: Theme__Color.toString(v.background),
          color: Theme__Color.toString(v.color),
          borderColor: Theme__Color.toString(v.borderColor)
        };
}

function chatWindowToJs(v) {
  return {
          background: Theme__Color.toString(v.background)
        };
}

function toJs(theme) {
  return {
          incomingMessage: messageToJs(theme.incomingMessage),
          outgoingMessage: messageToJs(theme.outgoingMessage),
          chatWindow: chatWindowToJs(theme.chatWindow)
        };
}

var primaryTheme_incomingMessage = {
  background: Theme__Color.wildSand,
  color: Theme__Color.doveGray,
  borderColor: Theme__Color.gallery
};

var primaryTheme_outgoingMessage = {
  background: Theme__Color.stTropaz,
  color: Theme__Color.white,
  borderColor: Theme__Color.stTropaz
};

var primaryTheme_chatWindow = {
  background: Theme__Color.white
};

var primaryTheme = {
  incomingMessage: primaryTheme_incomingMessage,
  outgoingMessage: primaryTheme_outgoingMessage,
  chatWindow: primaryTheme_chatWindow
};

var secondaryTheme_incomingMessage = {
  background: Theme__Color.white,
  color: Theme__Color.doveGray,
  borderColor: Theme__Color.gallery
};

var secondaryTheme_outgoingMessage = {
  background: Theme__Color.stTropaz,
  color: Theme__Color.white,
  borderColor: Theme__Color.stTropaz
};

var secondaryTheme_chatWindow = {
  background: Theme__Color.alabasterAlt
};

var secondaryTheme = {
  incomingMessage: secondaryTheme_incomingMessage,
  outgoingMessage: secondaryTheme_outgoingMessage,
  chatWindow: secondaryTheme_chatWindow
};

var ChatTheme = {
  messageToJs: messageToJs,
  chatWindowToJs: chatWindowToJs,
  toJs: toJs,
  primaryTheme: primaryTheme,
  secondaryTheme: secondaryTheme
};

var wrapper = Curry._1(Css.style, {
      hd: Css.position("relative"),
      tl: {
        hd: Css.display("inlineBlock"),
        tl: /* [] */0
      }
    });

var smallIconStyle = Curry._1(Css.style, {
      hd: Css.position("absolute"),
      tl: {
        hd: Css.right(Css.pct(-8)),
        tl: {
          hd: Css.top(Css.pct(58)),
          tl: {
            hd: Css.opacity(0.4),
            tl: /* [] */0
          }
        }
      }
    });

function Chat__Jsx3$ChatAvatar(props) {
  var overlayIcon = props.overlayIcon;
  var name = props.name;
  var src = props.src;
  return React.createElement(View__Jsx3.make, {
              mr: {
                NAME: "px",
                VAL: 10
              },
              children: Caml_option.some(overlayIcon !== undefined ? React.createElement("span", {
                          className: wrapper
                        }, React.createElement("span", {
                              className: smallIconStyle
                            }, React.createElement(Icon__Jsx3.make, {
                                  icon: overlayIcon,
                                  size: 20,
                                  color: props.iconColor
                                })), React.createElement(Avatar__Jsx3.make, {
                              src: src,
                              name: name,
                              size: "tiny"
                            })) : React.createElement(Avatar__Jsx3.make, {
                          src: src,
                          name: name,
                          size: "tiny"
                        }))
            });
}

var ChatAvatar = {
  wrapper: wrapper,
  smallIconStyle: smallIconStyle,
  make: Chat__Jsx3$ChatAvatar
};

var Message = {};

function Chat__Jsx3$MessageGroup(props) {
  return React.createElement(View__Jsx3.make, {
              mb: {
                NAME: "px",
                VAL: 15
              },
              flexDirection: "column",
              children: Caml_option.some(props.children)
            });
}

var MessageGroup = {
  make: Chat__Jsx3$MessageGroup
};

function Chat__Jsx3$MessagesContainer(props) {
  var height = props.height;
  var height$1 = height !== undefined ? height : ({
        NAME: "px",
        VAL: 480
      });
  return React.createElement(ViewStack.make, {
              height: height$1,
              flexDirection: "column",
              overflow: "auto",
              children: Caml_option.some(props.children)
            });
}

var MessagesContainer = {
  make: Chat__Jsx3$MessagesContainer
};

var JS$1 = {};

function Chat__Jsx3$ChatWindow(props) {
  return React.createElement(Chat.ChatWindow, {
              onClickExpandChat: props.onClickExpandChat,
              theme: Belt_Option.map(props.theme, toJs),
              children: props.children
            });
}

var ChatWindow = {
  JS: JS$1,
  make: Chat__Jsx3$ChatWindow
};

exports.ConversationHeader = ConversationHeader;
exports.DayDivider = DayDivider;
exports.ChatTheme = ChatTheme;
exports.ChatAvatar = ChatAvatar;
exports.Message = Message;
exports.MessageGroup = MessageGroup;
exports.MessagesContainer = MessagesContainer;
exports.ChatWindow = ChatWindow;
/* wrapper Not a pure module */
